import { render, staticRenderFns } from "./SelectCustomerModal.vue?vue&type=template&id=42f2d920"
import script from "./SelectCustomerModal.vue?vue&type=script&lang=js"
export * from "./SelectCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports